import axios from 'axios';
import { takeLatest, call, put, select } from 'redux-saga/effects';
import reverse from 'lodash/reverse';
import {
  fetchApptServiceSuccess,
  postHistoryFlowSuccess,
  putHistoryFlowSuccess,
  postMrrFlowSuccess,
  putMrrFlowSuccess,
  postScribeFlowSuccess,
  putScribeFlowSuccess,
  postRfaFlowSuccess,
  putRfaFlowSuccess,
  putInsuranceDetailsSuccess,
  fetchApptService,
  postHistoryFlow,
  putHistoryFlow,
  postMrrFlow,
  putMrrFlow,
  postScribeFlow,
  putScribeFlow,
  postRfaFlow,
  putRfaFlow,
  putInsuranceDetails,
  toggleHistory,
  toggleMrr,
  toggleRFA,
  toggleScribe,
  fetchAppointmentsByDateSuccess,
  fetchAppointmentsByPatientSuccess,
  fetchFlowSummariesByDateSuccess,
  fetchAppointmentsByDate,
  fetchAppointmentsByPatient,
  fetchFlowSummariesByDate,
  putHistoryFileUrls,
  putMrrFileUrls,
  putScribeFileUrls,
  putRfaFileUrls,
  putHistoryNotes,
  putMrrNotes,
  putScribeNotes,
  putRfaNotes,
  fetchMrrByAppointmentIdSuccess,
  fetchMrrByAppointmentId,
  fetchPatientDetails,
  putPatientDetailsSuccess,
  pwsMrrFlowSelector,
  markNotificationSeen,
  fetchNotifications,
  markNotificationSeenSuccess,
  fetchNotificationsSuccess,
} from './slice';
import { apiErrorHandler } from '../Utils/apiErrorHandler';
import { chrApi, phrApi, pwsApi } from '../../api/api';
import { showLoader } from '../globalReducer';
import { toast } from 'react-toastify';
import { push } from 'connected-react-router';
import { normalizeApptsByDate } from '../Home/home-slice';
import { normalizePatientAppts } from '../Patient/patient-slice';

function* _fetchApptService(action) {
  try {
    yield put(showLoader(true));
    const { appointmentId } = action.payload;
    const { data } = yield call(() => chrApi('get', `appointment/flows/${appointmentId}`, null, null));
    yield put(fetchApptServiceSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _postHistoryFlow(action) {
  try {
    yield put(showLoader(true));
    const { payload } = action.payload;
    const { data } = yield call(() => pwsApi('post', 'history_flow', payload, null));
    toast.success('History service successfully requested ');
    yield put(toggleHistory());
    yield put(postHistoryFlowSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _putHistoryFlow(action) {
  try {
    const { data: _data, id } = action.payload;
    const { data } = yield call(() => pwsApi('put', `history_flow/${id}`, _data, null));
    // TODO: update files in the pwsflow object
    yield put(putHistoryFlowSuccess({ data }));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _postMrrFlow(action) {
  try {
    yield put(showLoader(true));
    const { payload } = action.payload;
    const { data } = yield call(() => pwsApi('post', 'mrr_flow', payload, null));
    toast.success('Review service successfully requested ');
    yield put(toggleMrr());
    yield put(postMrrFlowSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _putMrrFlow(action) {
  try {
    const { isPatient, from, to, type, patientId, mrrObj = undefined, pathname, userType, appointmentId } = action.payload;
    yield put(showLoader(true));
    let mrrFlow;
    if (mrrObj) {
      mrrFlow = mrrObj;
    } else {
      mrrFlow = yield select(pwsMrrFlowSelector);
    }
    const { data } = yield call(() => pwsApi('put', `mrr_flow/${mrrFlow.id}`, mrrFlow, null));
    // toast.success('Review service successfully requested ');
    yield put(putMrrFlowSuccess({ data }));
    yield put(showLoader(false));
    if (isPatient === 'true') {
      yield put(push(`/patient/${patientId}`));
    } else if (userType === 'KuraMDMrr') {
      yield put(push(`/link2_md/home/appointment/${appointmentId}`));
    } else {
      yield put(push(pathname === '/appointment' ? `/appointment?from=${from}&to=${to}&type=${type}` : pathname));
    }
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _postScribeFlow(action) {
  try {
    yield put(showLoader(true));
    const { payload } = action.payload;
    const { data } = yield call(() => pwsApi('post', 'scribe_flow', payload, null));
    toast.success('Dication service successfully requested ');
    yield put(toggleScribe());
    yield put(postScribeFlowSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _putScribeFlow(action) {
  try {
    yield put(putScribeFlowSuccess('some Data'));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _postRfaFlow(action) {
  try {
    yield put(showLoader(true));
    const { payload } = action.payload;
    const { data } = yield call(() => pwsApi('post', 'rfa_flow', payload, null));
    toast.success('Authorization service successfully requested ');
    yield put(toggleMrr());
    yield put(postRfaFlowSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _putRfaFlow(action) {
  try {
    yield put(putRfaFlowSuccess('some Data'));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _putInsuranceDetails(action) {
  try {
    yield put(showLoader(true));
    const { payload, insuranceId } = action.payload;
    const { data } = yield call(() => chrApi('put', `insurance_details_data/${insuranceId}`, payload, null));
    toast.success('Insurance details successfully added');
    yield put(showLoader(false));
    yield put(putInsuranceDetailsSuccess({ data }));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

function* _fetchAppointmentsByDate(action) {
  try {
    yield put(showLoader(true));
    const { startDate, endDate, practiceId, providerId, type } = action.payload;
    let url = `appointment/flows/practice/${practiceId}/provider/${providerId}/date/${startDate}`;
    if (endDate && (type === 'Week View' || type === 'Range View')) {
      url += `/${endDate}`;
    }
    const { data } = yield call(() => chrApi('get', url, null, null));
    yield put(fetchAppointmentsByDateSuccess({ data }));
    yield put(normalizeApptsByDate({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _fetchAppointmentsByPatient(action) {
  try {
    yield put(showLoader(true));
    const { practiceId, patientId, queryApptId } = action.payload;
    const { data } = yield call(() => chrApi('get', `appointment/flows/practice/${practiceId}/patient/${patientId} `, null, null));
    if (Array.isArray(data) && data.length > 0) {
      const [a] = data;
      const { id: appointmentId } = a;
      console.log(Number(queryApptId));
      Number(queryApptId) ? yield put(fetchApptService({ appointmentId: queryApptId })) : yield put(fetchApptService({ appointmentId }));
    }
    if (Array.isArray(data) && data.length === 0) {
      yield put(fetchPatientDetails({ patientId }));
    }
    yield put(normalizePatientAppts({ data }));
    yield put(fetchAppointmentsByPatientSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _fetchFlowSummariesByDate(action) {
  try {
    yield put(showLoader(true));
    const { startDate, endDate, practiceId, providerId, type } = action.payload;
    let url = `appointment/flows_summary/practice/${practiceId}/provider/${providerId}/date/${startDate}`;
    if (endDate && (type === 'Week View' || type === 'Range View')) {
      url += `/${endDate}`;
    }
    const { data } = yield call(() => chrApi('get', url, null, null));
    yield put(fetchFlowSummariesByDateSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

function* _putHistoryFileUrls(action) {
  try {
    yield put(showLoader(true));
    const { fileUrls, id } = action.payload;
    const { data } = yield call(() => pwsApi('put', `history_flow_files/${id}`, fileUrls, null));
    yield put(putHistoryFlowSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _putMrrFileUrls(action) {
  try {
    yield put(showLoader(true));
    const { fileUrls, id } = action.payload;
    const { data } = yield call(() => pwsApi('put', `mrr_flow_files/${id}`, fileUrls, null));
    yield put(putMrrFlowSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _putScribeFileUrls(action) {
  try {
    yield put(showLoader(true));
    const { fileUrls, id } = action.payload;
    const { data } = yield call(() => pwsApi('put', `scribe_flow_files/${id}`, fileUrls, null));
    yield put(putScribeFlowSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _putRfaFileUrls(action) {
  try {
    yield put(showLoader(true));
    const { fileUrls, id } = action.payload;
    const { data } = yield call(() => pwsApi('put', `rfa_flow_files/${id}`, fileUrls, null));
    yield put(putRfaFlowSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

function* _putHistoryNotes(action) {
  try {
    yield put(showLoader(true));
    const { note, id } = action.payload;
    const { data = {} } = yield call(() => pwsApi('put', `history_flow_issues/${id}`, note, null));
    yield put(putHistoryFlowSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _putMrrNotes(action) {
  try {
    yield put(showLoader(true));
    const { note, id } = action.payload;
    const { data = {} } = yield call(() => pwsApi('put', `mrr_flow_issues/${id}`, note, null));
    yield put(putMrrFlowSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _putScribeNotes(action) {
  try {
    yield put(showLoader(true));
    const { note, id } = action.payload;
    const { data = {} } = yield call(() => pwsApi('put', `scribe_flow_issues/${id}`, note, null));
    yield put(putScribeFlowSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _putRfaNotes(action) {
  try {
    yield put(showLoader(true));
    const { note, id } = action.payload;
    const { data = {} } = yield call(() => pwsApi('put', `rfa_flow_issues/${id}`, note, null));
    yield put(putRfaFlowSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

function* _fetchMrrByAppointmentId(action) {
  try {
    yield put(showLoader(true));
    const { appointmentId } = action.payload;
    const { data } = yield call(() => pwsApi('get', `/mrr_flow/appointment/${appointmentId}`, null, null));
    yield put(fetchMrrByAppointmentIdSuccess({ data: data || {} }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

function* _fetchPatientDetails(action) {
  try {
    yield put(showLoader(true));
    const { patientId } = action.payload;
    const { data } = yield call(() => chrApi('get', `/patient/${patientId}`, null, null));
    yield put(putPatientDetailsSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

function* _markNotificationSeen(action) {
  try {
    yield put(showLoader(true));
    const { data } = yield call(() => phrApi('put', 'seen_notification', [action.payload], null));
    yield put(markNotificationSeenSuccess({ data: { id: action.payload } }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _fetchNotifications(action) {
  try {
    yield put(showLoader(true));
    const { data } = yield call(() => phrApi('get', 'all_notification', null, null));
    yield put(fetchNotificationsSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* fetchApptServiceSaga() {
  yield takeLatest(fetchApptService.type, _fetchApptService);
}
export function* postHistoryFlowSaga() {
  yield takeLatest(postHistoryFlow.type, _postHistoryFlow);
}
export function* putHistoryFlowSaga() {
  yield takeLatest(putHistoryFlow.type, _putHistoryFlow);
}
export function* postMrrFlowSaga() {
  yield takeLatest(postMrrFlow.type, _postMrrFlow);
}
export function* putMrrFlowSaga() {
  yield takeLatest(putMrrFlow.type, _putMrrFlow);
}
export function* postScribeFlowSaga() {
  yield takeLatest(postScribeFlow.type, _postScribeFlow);
}
export function* putScribeFlowSaga() {
  yield takeLatest(putScribeFlow.type, _putScribeFlow);
}
export function* postRfaFlowSaga() {
  yield takeLatest(postRfaFlow.type, _postRfaFlow);
}
export function* putRfaFlowSaga() {
  yield takeLatest(putRfaFlow.type, _putRfaFlow);
}
export function* putInsuranceDetailsSaga() {
  yield takeLatest(putInsuranceDetails.type, _putInsuranceDetails);
}

export function* fetchAppointmentsByDateSaga() {
  yield takeLatest(fetchAppointmentsByDate.type, _fetchAppointmentsByDate);
}
export function* fetchAppointmentsByPatientSaga() {
  yield takeLatest(fetchAppointmentsByPatient.type, _fetchAppointmentsByPatient);
}
export function* fetchFlowSummariesByDateSaga() {
  yield takeLatest(fetchFlowSummariesByDate.type, _fetchFlowSummariesByDate);
}

export function* putHistoryFileUrlsSaga() {
  yield takeLatest(putHistoryFileUrls.type, _putHistoryFileUrls);
}
export function* putMrrFileUrlsSaga() {
  yield takeLatest(putMrrFileUrls.type, _putMrrFileUrls);
}
export function* putScribeFileUrlsSaga() {
  yield takeLatest(putScribeFileUrls.type, _putScribeFileUrls);
}
export function* putRfaFileUrlsSaga() {
  yield takeLatest(putRfaFileUrls.type, _putRfaFileUrls);
}

export function* putHistoryNotesSaga() {
  yield takeLatest(putHistoryNotes.type, _putHistoryNotes);
}
export function* putMrrNotesSaga() {
  yield takeLatest(putMrrNotes.type, _putMrrNotes);
}
export function* putScribeNotesSaga() {
  yield takeLatest(putScribeNotes.type, _putScribeNotes);
}
export function* putRfaNotesSaga() {
  yield takeLatest(putRfaNotes.type, _putRfaNotes);
}

export function* fetchMrrByAppointmentIdSaga() {
  yield takeLatest(fetchMrrByAppointmentId.type, _fetchMrrByAppointmentId);
}

export function* fetchPatientDetailsSaga() {
  yield takeLatest(fetchPatientDetails.type, _fetchPatientDetails);
}

export function* markNotificationSeenSaga() {
  yield takeLatest(markNotificationSeen.type, _markNotificationSeen);
}

export function* fetchNotificationsSaga() {
  yield takeLatest(fetchNotifications.type, _fetchNotifications);
}
